module.exports = __webpack_public_path__ + "img/logo-dghno-text.286bfe9e.svg";